import React from "react";
import { SystemPromptButton } from "./components/SystemPromptButton";
import { SystemPromptPopup } from "./components/SystemPromptPopup";
import { useSystemPromptContext } from "./context/SystemPromptContext";

interface Props {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  isInside: boolean;
  disabled?: boolean;
}

export const SystemPrompt: React.FC<Props> = ({ onMouseEnter, onMouseLeave, isInside, disabled = false }) => {
  const systemPrompt = useSystemPromptContext();

  if (!systemPrompt.isEnabled) {
    return null;
  }

  return (
    <>
      <SystemPromptButton
        onClick={systemPrompt.openPopup}
        disabled={disabled || systemPrompt.isLoading}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        isInside={isInside}
        hasCustomPrompt={systemPrompt.hasCustom}
      />

      <SystemPromptPopup
        isOpen={systemPrompt.isPopupOpen}
        onClose={systemPrompt.closePopup}
        onSave={systemPrompt.handleSave}
        onReset={systemPrompt.handleReset}
        savedPrompt={systemPrompt.savedPrompt}
        freshPrompt={systemPrompt.freshPrompt}
        isLoading={systemPrompt.isLoading}
      />
    </>
  );
};
